import * as React from 'react';
import { PromoBannerProps } from './PromoBanner.props';
import {
  StyledPBContent,
  StyledPBContentContainer,
  StyledPBImage,
  StyledPBImageContainer,
  StyledPromoBanner,
} from './PromoBanner.styles';

export const PromoBanner = ({
  backgroundSrc,
  children,
  imageAlt,
  imageSrc,
  invertColors,
  isImageWide,
  testId,
}: PromoBannerProps) => {
  const testProps = testId && { 'data-testid': testId };

  return (
    <StyledPromoBanner backgroundSrc={backgroundSrc} invertColors={invertColors} {...testProps}>
      <StyledPBImageContainer>
        <StyledPBImage alt={imageAlt} isImageWide={isImageWide} src={imageSrc} />
      </StyledPBImageContainer>
      <StyledPBContentContainer>
        <StyledPBContent invertColors={invertColors}>{children}</StyledPBContent>
      </StyledPBContentContainer>
    </StyledPromoBanner>
  );
};
